import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import type { GetAdminV1OrgMediaParams } from '@nucleus-commerce/api-client/admin';

import { mediaApi } from '../api/media-api';

import { mediaKeys } from './media-keys';

export type MediaListParams = Omit<GetAdminV1OrgMediaParams, 'cursor'>;

/** A grid grows downwards, so the library pages with "load more" instead of next/previous. */
export function mediaListQueryOptions(params: MediaListParams) {
  return infiniteQueryOptions({
    queryKey: mediaKeys.list(params),
    queryFn: ({ pageParam }) =>
      mediaApi.list({ ...params, ...(pageParam ? { cursor: pageParam } : {}) }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}

export function useMediaList(params: MediaListParams) {
  return useInfiniteQuery(mediaListQueryOptions(params));
}
